import { Component, ViewEncapsulation } from '@angular/core';
import { fadeInOnEnterAnimation, fadeOutOnLeaveAnimation } from '../../../animations/index';

@Component({
  selector: 'app-content-empty-cabinet',
  templateUrl: './content-empty.component.html',
  styleUrl: './content-empty.component.scss',
  encapsulation: ViewEncapsulation.ShadowDom,
  animations: [fadeInOnEnterAnimation(), fadeOutOnLeaveAnimation()]
})
export class ContentEmptyCabinetComponent {}
